import React from 'react';
import { Watch, Activity, MapPin, Smartphone } from 'lucide-react';

const IntegrationsSection: React.FC = () => {
  const integrations = [
    { name: 'Apple Watch', icon: <Watch className="w-12 h-12" /> },
    { name: 'Fitbit', icon: <Activity className="w-12 h-12" /> },
    { name: 'Garmin', icon: <MapPin className="w-12 h-12" /> },
    { name: 'Google Fit', icon: <Smartphone className="w-12 h-12" /> },
    { name: 'Apple Health', icon: <Smartphone className="w-12 h-12" /> },
  ];

  return (
    <section className="py-20 bg-gray-50 dark:bg-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-4">
            Quick Connections. Instant Synchronization.
          </h2>
          <p className="text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
            Effortless connectivity with every platform and wearable device to continuously track your wellness.
          </p>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-8 md:gap-12">
          {integrations.map((integration, index) => (
            <div
              key={index}
              className="flex flex-col items-center p-6 bg-white dark:bg-slate-700 rounded-xl shadow-md hover:shadow-lg transition-shadow min-w-[120px]"
            >
              <div className="text-purple-600 dark:text-purple-400 mb-4">
                {integration.icon}
              </div>
              <p className="text-gray-700 dark:text-gray-300 font-medium text-center">
                {integration.name}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-lg text-gray-600 dark:text-gray-300">
            Use Your Preferred Devices
          </p>
        </div>
      </div>
    </section>
  );
};

export default IntegrationsSection;

